import { Injectable, inject } from '@angular/core';
import type {
  CreateGalleryResult,
  GalleryCategoryFilterOption,
  GalleryListItem,
  GalleryPage,
  GalleryStatus,
  GalleryTrashItem,
} from '../entities/galleries.models';
import type { GalleriesDataPort, GalleryOpFailure, GalleryPageParams } from './galleries.data';
import { GalleriesApiService } from './galleries-api.service';

@Injectable({ providedIn: 'root' })
export class HttpGalleriesData implements GalleriesDataPort {
  private readonly api = inject(GalleriesApiService);

  list(params?: GalleryPageParams): Promise<GalleryPage<GalleryListItem> | null> {
    return this.api.getList(params);
  }

  create(title: string, presetId?: string | null): Promise<CreateGalleryResult> {
    return this.api.create(title, presetId);
  }

  duplicate(galleryId: string): Promise<string | null> {
    return this.api.duplicate(galleryId);
  }

  rename(galleryId: string, title: string): Promise<boolean> {
    return this.api.rename(galleryId, title);
  }

  setStatus(galleryId: string, status: GalleryStatus): Promise<GalleryOpFailure | null> {
    return this.api.setStatus(galleryId, status);
  }

  delete(galleryId: string): Promise<GalleryOpFailure | null> {
    return this.api.delete(galleryId);
  }

  applyCategories(
    galleryId: string,
    add: readonly string[],
    remove: readonly string[],
    createNames?: readonly string[],
  ): Promise<GalleryOpFailure | null> {
    return this.api.applyCategories(galleryId, add, remove, createNames);
  }

  trash(params?: GalleryPageParams): Promise<GalleryPage<GalleryTrashItem> | null> {
    return this.api.getTrash(params);
  }

  restore(galleryId: string): Promise<boolean> {
    return this.api.restore(galleryId);
  }

  purge(galleryId: string): Promise<boolean> {
    return this.api.purge(galleryId);
  }

  emptyTrash(): Promise<boolean> {
    return this.api.emptyTrash();
  }

  categoryVocabulary(): Promise<GalleryCategoryFilterOption[] | null> {
    return this.api.categoryVocabulary();
  }
}
